// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AddressAutocompleteController from "./address_autocomplete_controller"
application.register("address-autocomplete", AddressAutocompleteController)

import AdminNavController from "./admin_nav_controller"
application.register("admin-nav", AdminNavController)

import AnswerRulesController from "./answer_rules_controller"
application.register("answer-rules", AnswerRulesController)

import AutoSubmitController from "./auto_submit_controller"
application.register("auto-submit", AutoSubmitController)

import AutocompleteController from "./autocomplete_controller"
application.register("autocomplete", AutocompleteController)

import AvatarUploadController from "./avatar_upload_controller"
application.register("avatar-upload", AvatarUploadController)

import BlockMapPickerController from "./block_map_picker_controller"
application.register("block-map-picker", BlockMapPickerController)

import BrandingEditorController from "./branding_editor_controller"
application.register("branding-editor", BrandingEditorController)

import CarouselController from "./carousel_controller"
application.register("carousel", CarouselController)

import CategoryCheckboxController from "./category_checkbox_controller"
application.register("category-checkbox", CategoryCheckboxController)

import CertificationDatesController from "./certification_dates_controller"
application.register("certification-dates", CertificationDatesController)

import CertificationFormController from "./certification_form_controller"
application.register("certification-form", CertificationFormController)

import CertificationHolderController from "./certification_holder_controller"
application.register("certification-holder", CertificationHolderController)

import CheckboxSelectAllController from "./checkbox_select_all_controller"
application.register("checkbox-select-all", CheckboxSelectAllController)

import ChoiceOptionsController from "./choice_options_controller"
application.register("choice-options", ChoiceOptionsController)

import ClientsSearchController from "./clients_search_controller"
application.register("clients-search", ClientsSearchController)

import CollapsibleController from "./collapsible_controller"
application.register("collapsible", CollapsibleController)

import ColumnMappingController from "./column_mapping_controller"
application.register("column-mapping", ColumnMappingController)

import CompanyAutocompleteController from "./company_autocomplete_controller"
application.register("company-autocomplete", CompanyAutocompleteController)

import CompareMapController from "./compare_map_controller"
application.register("compare-map", CompareMapController)

import ConfirmationController from "./confirmation_controller"
application.register("confirmation", ConfirmationController)

import CsvUploadController from "./csv_upload_controller"
application.register("csv-upload", CsvUploadController)

import DemoSlotPickerController from "./demo_slot_picker_controller"
application.register("demo-slot-picker", DemoSlotPickerController)

import DialogController from "./dialog_controller"
application.register("dialog", DialogController)

import DirectUploadController from "./direct_upload_controller"
import DrawingUploadController from "./drawing_upload_controller"
application.register("direct-upload", DirectUploadController)
application.register("drawing-upload", DrawingUploadController)

import DrawerController from "./drawer_controller"
application.register("drawer", DrawerController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import DropdownPopoverController from "./dropdown_popover_controller"
application.register("dropdown-popover", DropdownPopoverController)

import DueBulkScheduleController from "./due_bulk_schedule_controller"
application.register("due-bulk-schedule", DueBulkScheduleController)
import DueBulkTrainingController from "./due_bulk_training_controller"
application.register("due-bulk-training", DueBulkTrainingController)

import DueWorksProjectController from "./due_works_project_controller"
application.register("due-works-project", DueWorksProjectController)

import EditFullFormController from "./edit_full_form_controller"
application.register("edit-full-form", EditFullFormController)

import EditFullPhotoController from "./edit_full_photo_controller"
application.register("edit-full-photo", EditFullPhotoController)

import EvidenceDropzoneController from "./evidence_dropzone_controller"
application.register("evidence-dropzone", EvidenceDropzoneController)

import ExportFilenameController from "./export_filename_controller"
application.register("export-filename", ExportFilenameController)

import ExportFormatController from "./export_format_controller"
application.register("export-format", ExportFormatController)

import FieldKeyGeneratorController from "./field_key_generator_controller"
application.register("field-key-generator", FieldKeyGeneratorController)

import FieldLogicController from "./field_logic_controller"
application.register("field-logic", FieldLogicController)

import FileUploadController from "./file_upload_controller"
application.register("file-upload", FileUploadController)

import FilesDropzoneController from "./files_dropzone_controller"
application.register("files-dropzone", FilesDropzoneController)

import FilesUploadQueueController from "./files_upload_queue_controller"
application.register("files-upload-queue", FilesUploadQueueController)

import FilesTreeController from "./files_tree_controller"
application.register("files-tree", FilesTreeController)

import FilterController from "./filter_controller"
application.register("filter", FilterController)

import FilterDrawerController from "./filter_drawer_controller"
application.register("filter-drawer", FilterDrawerController)

import FingerprintController from "./fingerprint_controller"
application.register("fingerprint", FingerprintController)

import FloorplanViewerController from "./floorplan_viewer_controller"
application.register("floorplan-viewer", FloorplanViewerController)

import FloorplanPagesController from "./floorplan_pages_controller"
application.register("floorplan-pages", FloorplanPagesController)

import FloorplanPinCaptureController from "./floorplan_pin_capture_controller"
application.register("floorplan-pin-capture", FloorplanPinCaptureController)

import FormBuilderController from "./form_builder_controller"
import AddFieldsController from "./add_fields_controller"
application.register("form-builder", FormBuilderController)
application.register("add-fields", AddFieldsController)

import FormOutlineController from "./form_outline_controller"
application.register("form-outline", FormOutlineController)

import SpineDisclosureController from "./spine_disclosure_controller"
application.register("spine-disclosure", SpineDisclosureController)

import FormFieldController from "./form_field_controller"
application.register("form-field", FormFieldController)

import FormPickerController from "./form_picker_controller"
application.register("form-picker", FormPickerController)


import FormSectionController from "./form_section_controller"
application.register("form-section", FormSectionController)

import SectionTitleController from "./section_title_controller"
application.register("section-title", SectionTitleController)

import FrameFilterController from "./frame_filter_controller"
application.register("frame-filter", FrameFilterController)
import PeriodJumpController from "./period_jump_controller"
application.register("period-jump", PeriodJumpController)

import GroupSelectController from "./group_select_controller"
application.register("group-select", GroupSelectController)

import ImageFallbackController from "./image_fallback_controller"
application.register("image-fallback", ImageFallbackController)

import LightboxController from "./lightbox_controller"
application.register("lightbox", LightboxController)

import LegalGateController from "./legal_gate_controller"
application.register("legal-gate", LegalGateController)

import LockedNoticeController from "./locked_notice_controller"
application.register("locked-notice", LockedNoticeController)

import ListSearchController from "./list_search_controller"
application.register("list-search", ListSearchController)

import LogoUploadController from "./logo_upload_controller"
application.register("logo-upload", LogoUploadController)

import MapPickerController from "./map_picker_controller"
application.register("map-picker", MapPickerController)

import PatchMapController from "./patch_map_controller"
application.register("patch-map", PatchMapController)

import SitesMapController from "./sites_map_controller"
application.register("sites-map", SitesMapController)

import AssetsMapController from "./assets_map_controller"
application.register("assets-map", AssetsMapController)

import PlansViewerController from "./plans_viewer_controller"
application.register("plans-viewer", PlansViewerController)

import PickerModalController from "./picker_modal_controller"
application.register("picker-modal", PickerModalController)

import MemberSignatureUploadController from "./member_signature_upload_controller"
application.register("member-signature-upload", MemberSignatureUploadController)

import MenuController from "./menu_controller"
application.register("menu", MenuController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import MultiSelectController from "./multi_select_controller"
application.register("multi-select", MultiSelectController)

import NestedFormController from "./nested_form_controller"
application.register("nested-form", NestedFormController)

import PasswordController from "./password_controller"
application.register("password", PasswordController)

import PasswordStrengthController from "./password_strength_controller"
application.register("password-strength", PasswordStrengthController)

import PdfCertificateViewerController from "./pdf_certificate_viewer_controller"
application.register("pdf-certificate-viewer", PdfCertificateViewerController)

import ProductInstallerController from "./product_installer_controller"
application.register("product-installer", ProductInstallerController)

import ProgressBarController from "./progress_bar_controller"
application.register("progress-bar", ProgressBarController)

import QrScannerController from "./qr_scanner_controller"
application.register("qr-scanner", QrScannerController)

import QtagOrderShopController from "./qtag_order_shop_controller"
application.register("qtag-order-shop", QtagOrderShopController)

import RailsBlocks__DatatableController from "./rails_blocks/datatable_controller"
application.register("rails-blocks--datatable", RailsBlocks__DatatableController)
// Bare alias: AppUi::DataList renders data-controller="datatable" (the un-namespaced
// identifier, like the project's other bare controllers — modal, slideover, frame-filter).
// Without this, the bare "datatable" identifier matched nothing and DataList sort/filter
// headers were inert app-wide.
application.register("datatable", RailsBlocks__DatatableController)

import RailsBlocks__StepperController from "./rails_blocks/stepper_controller"
application.register("rails-blocks--stepper", RailsBlocks__StepperController)

import RatingController from "./rating_controller"
application.register("rating", RatingController)

import ReportDesignerController from "./report_designer_controller"
application.register("report-designer", ReportDesignerController)

import ReportDesignFilenameController from "./report_design_filename_controller"
application.register("report-design-filename", ReportDesignFilenameController)

import RepeatableSectionController from "./repeatable_section_controller"
application.register("repeatable-section", RepeatableSectionController)

import RepeatableToggleController from "./repeatable_toggle_controller"
application.register("repeatable-toggle", RepeatableToggleController)

import ScrollToTopController from "./scroll_to_top_controller"
application.register("scroll-to-top", ScrollToTopController)

import SearchController from "./search_controller"
application.register("search", SearchController)

import SelectController from "./select_controller"
application.register("select", SelectController)

import SidebarController from "./sidebar_controller"
application.register("sidebar", SidebarController)

import SiteDirectionsController from "./site_directions_controller"
application.register("site-directions", SiteDirectionsController)

import SignatureController from "./signature_controller"
application.register("signature", SignatureController)

import SlideoverController from "./slideover_controller"
application.register("slideover", SlideoverController)

import SlideoverLaunchController from "./slideover_launch_controller"
application.register("slideover-launch", SlideoverLaunchController)

import SortDropdownController from "./sort_dropdown_controller"
application.register("sort-dropdown", SortDropdownController)

import SortableListController from "./sortable_list_controller"
application.register("sortable-list", SortableListController)

import StepValidationController from "./step_validation_controller"
application.register("step-validation", StepValidationController)

import SubNavPanelController from "./sub_nav_panel_controller"
application.register("sub-nav-panel", SubNavPanelController)

import SubmissionFiltersController from "./submission_filters_controller"
application.register("submission-filters", SubmissionFiltersController)

import SubmissionWizardController from "./submission_wizard_controller"
application.register("submission-wizard", SubmissionWizardController)

import WizardPreviewController from "./wizard_preview_controller"
application.register("wizard-preview", WizardPreviewController)

import SubmissionsChartController from "./submissions_chart_controller"
application.register("submissions-chart", SubmissionsChartController)

import EmailChipsController from "./email_chips_controller"
application.register("email-chips", EmailChipsController)

import DonutChartController from "./donut_chart_controller"
application.register("donut-chart", DonutChartController)

import TabsController from "./tabs_controller"
application.register("tabs", TabsController)

import ToastController from "./toast_controller"
application.register("toast", ToastController)

import ToggleSwitchController from "./toggle_switch_controller"
application.register("toggle-switch", ToggleSwitchController)

import TooltipController from "./tooltip_controller"
application.register("tooltip", TooltipController)

import WwwHeaderController from "./www_header_controller"
application.register("www-header", WwwHeaderController)

import WwwAnalyticsController from "./www_analytics_controller"
application.register("www-analytics", WwwAnalyticsController)

import WwwBuildingSceneController from "./www_building_scene_controller"
application.register("www-building-scene", WwwBuildingSceneController)

import WwwScanFlowController from "./www_scan_flow_controller"
application.register("www-scan-flow", WwwScanFlowController)

import WwwFigurePlayController from "./www_figure_play_controller"
application.register("www-figure-play", WwwFigurePlayController)

import OrderedPickerController from "./ordered_picker_controller"
application.register("ordered-picker", OrderedPickerController)

import VisitScheduleFormController from "./visit_schedule_form_controller"
application.register("visit-schedule-form", VisitScheduleFormController)

import VisitDragController from "./visit_drag_controller"
application.register("visit-drag", VisitDragController)

import VisitScopePickerController from "./visit_scope_picker_controller"
application.register("visit-scope-picker", VisitScopePickerController)

import FormStartController from "./form_start_controller"
application.register("form-start", FormStartController)

import GenerationPollController from "./generation_poll_controller"
application.register("generation-poll", GenerationPollController)

import DismissibleController from "./dismissible_controller"
application.register("dismissible", DismissibleController)

import AssistantComposerController from "./assistant_composer_controller"
application.register("assistant-composer", AssistantComposerController)

import ThreadScrollController from "./thread_scroll_controller"
application.register("thread-scroll", ThreadScrollController)

import TypewriterController from "./typewriter_controller"
application.register("typewriter", TypewriterController)

import AssetRulesController from "./asset_rules_controller"
application.register("asset-rules", AssetRulesController)

import LinkQtagButtonController from "./link_qtag_button_controller"
application.register("link-qtag-button", LinkQtagButtonController)

import SessionFormController from "./session_form_controller"
application.register("session-form", SessionFormController)
